import React from 'react';
import { FilterOption } from './FilterOption';
import { FilterContainer, OptionsWrapper, Sidebar } from './style';
import { useAuth } from 'lib/context';
import { useIntegrationData } from '../main/hooks';

interface SidebarFilterProps {
  setSelectedFilters: React.Dispatch<React.SetStateAction<string[]>>;
  selectedFilters: string[];
  resetFilters: () => void;
}

export const SidebarFilter = ({
  setSelectedFilters,
  selectedFilters,
}: SidebarFilterProps) => {
  const {
    userData: { isAutomotive },
  } = useAuth();

  const data = useIntegrationData();
  const { CDS_CATEGORIES, INTEGRATIONS_CATEGORIES } = data;

  const options = isAutomotive
    ? { ...INTEGRATIONS_CATEGORIES, ...CDS_CATEGORIES }
    : INTEGRATIONS_CATEGORIES;
  return (
    <Sidebar>
      <FilterContainer>
        <OptionsWrapper>
          <FilterOption
            filterOptions={Object.values(options)}
            setSelectedFilters={setSelectedFilters}
            selectedFilters={selectedFilters}
            filterTypeText='CATEGORY'
          />
        </OptionsWrapper>
      </FilterContainer>
    </Sidebar>
  );
};
